'use client';
import { text5 } from '@osmosis/tailwind-ui/styles/text';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Card } from '@osmosis/tailwind-ui/components/Card';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { H3 } from '@osmosis/tailwind-ui/components/Text';

import { faShieldAlt } from '@fortawesome/pro-solid-svg-icons/faShieldAlt';
import FormattedMessage from '../../../../components/FormattedMessage';
import AssessmentsBlockClient from './AssessmentsBlockClient';
import { useLearnData } from '../../../../context/LearnDataProvider';
import { CommonLearnBlockProps } from '../LearnBlock';

type Props = {
  classNames?: {
    card?: string;
  };
} & CommonLearnBlockProps;

/**
 * AssessmentsBlock.
 */
export default function AssessmentsBlock({ classNames, contentOnly }: Props) {
  const { learnData } = useLearnData();
  const { flashcards, questions } = learnData?.sections || {};

  const hasAssessmentItems =
    flashcards?.list.length ||
    (questions && Object.values(questions).find((v) => v.list.length));

  return hasAssessmentItems ? (
    <Box className="mb-2" data-testid="assesment-block">
      <Card className={classNames?.card}>
        {contentOnly ? null : (
          <Flex className={`justify-between`}>
            <Flex data-testid="assessments-header" className={`flex-1`}>
              <Box className={`mr-2 ${text5}`}>
                <Icon icon={faShieldAlt} className={`text-2xl`} />
              </Box>
              <Box className={`flex-1`}>
                <H3 className={`mb-1`}>
                  <FormattedMessage
                    defaultMessage="Assessments"
                    id="common.assessments"
                  />
                </H3>
              </Box>
            </Flex>
          </Flex>
        )}

        <Flex className={`flex-col gap-4 mt-4`}>
          <AssessmentsBlockClient
            questions={questions}
            flashcards={flashcards}
          />
        </Flex>
      </Card>
    </Box>
  ) : null;
}
